<template lang="pug">
    div
        Row(type="flex" justify="space-between")
            p.title {{$t("security.security")}}
            Button.cardBtn(type="primary" @click="saveUserAllowIp") {{$t("security.save")}}
        List.content(item-layout="vertical")
            //- isUseUserAllowIp
            ListItem(style="position: relative;")
                ListItemMeta(:title="$t('security.isUseUserAllowIpTitle')" :description="$t('security.isUseUserAllowIpDescription')")
                template(slot="action")
                    i-switch(v-model="isUseUserAllowIp" style="position: absolute; top:50%; right:0")
            //- userAllowIp
            ListItem(v-if="isUseUserAllowIp")
                ListItemMeta(:title="$t('security.userAllowIpTitle')" :description="$t('security.userAllowIpDescription')")
                template(slot="action")
                    Form(style="width: 30vw" ref="security" :model="security" :rules="validateRule" )
                        FormItem(prop="userAllowIp")
                            Input(type="textarea" placeholder="A.B.C.D/netmask\nA.B.C.D/netmask" v-model="security.userAllowIp")
            //- device
            ListItem(v-if="$store.state.platformPlan.multiTenancyConfigs.deviceValidation")
                ListItemMeta(:title="$t('security.deviceTitle')" style="overflow: scroll")
                    template(slot="description")
                        Table(border :columns="deviceColumns" :data="deviceData")
            //- user login & logout records
            ListItem
                ListItemMeta(:title="$t('security.userLoginAndLogoutRecords')" style="overflow: scroll")
                    template(slot="description")
                        Table(border :columns="loginAndLogOutRecordsColumns" :data="loginAndLogOutRecordsInfosData")
</template>

<script>
import { ipValidate } from "@/api/formValidate";
import { setAllowIp, _deleteDevice, getUserData, getActiveSessions, destroyActiveSession } from "@/api/user";
import { _dateFormat } from "@/libs/dateformat.js";
import { getSessionHistory } from "@/libs/sessionHistory";

export default {
    data() {
        return {
            isUseUserAllowIp: this.$store.state.userData.isUseUserAllowIp,
            security: { userAllowIp: this.$store.state.userData.userAllowIp },
            ipValidate: false,
            validateRule: {
                userAllowIp: [
                    {
                        validator: (rule, value, callback) => {
                            if (value.length == 0) return callback();
                            let ipsValidation = value.split("\n");
                            ipsValidation.forEach((e, i) => {
                                let index = ipsValidation.findIndex((x) => x == e);
                                if (index !== i) return callback(new Error(`Duplicate: ${e}`));
                                if (/[\s]/.test(e)) return callback(new Error("invalid: " + e));
                            });
                            ipValidate("ipsValidation", ipsValidation).then((result) => {
                                if (!result.data.success) {
                                    return callback(new Error(result.data.message));
                                }
                                callback();
                            });
                        },
                        trigger: "blur",
                    },
                ],
            },
            loginAndLogOutRecordsInfosData: [],
            loginAndLogOutRecordsColumns: [
                {
                    title: this.$i18n.t("security.loginDate"),
                    key: "loginDate",
                    sortable: true,
                    width: "250",
                    render: (h, params) => {
                        let extendText = [];
                        const active = h("div", [
                            h("span", { style: { color: "green" } }, this.$i18n.t("security.active")),
                            h("Button", {
                                props: {
                                    icon: "md-log-out",
                                    size: "small",
                                    shape: "circle",
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            title: this.$i18n.t("rcmtable.confirmDeleteText"),
                                            okText: this.$i18n.t("rcmtable.confirmText"),
                                            cancelText: this.$i18n.t("rcmtable.cancelText"),
                                            onOk: () => {
                                                this.destroyActiveSession(params.row.sessionId);
                                            },
                                        });
                                    },
                                },
                            }),
                        ]);
                        const current = h("div", [
                            h("p", { style: { color: "red" } }, this.$i18n.t("security.current")),
                        ]);

                        let vm = this;
                        // 如果是 active 的 session，且不是當下的 session，push active
                        if (vm.$data.activeSessions.includes(params.row.sessionId) && !params.row.isCurrent) {
                            extendText.push(active);
                        }
                        // 如果是當下的 session，push current
                        if (params.row.isCurrent) {
                            extendText.push(current);
                        }
                        return h("div", [h("p", params.row.loginDate), extendText]);
                    },
                },
                {
                    title: this.$i18n.t("security.logoutDate"),
                    key: "logoutDate",
                    sortable: true,
                    width: "250",
                },
                {
                    title: this.$i18n.t("security.sessionDuration"),
                    key: "sessionDuration",
                    width: "250",
                    render: (h, params) => {
                        const loginDate = new Date(params.row.loginDateRaw); // 用 ISO
                        const diffMs = Date.now() - loginDate.getTime();
                        const isOver24h = diffMs > 24 * 3600 * 1000;

                        const text = params.row.sessionDuration || "";
                        return h(
                            "span",
                            {
                                style: {
                                    color: isOver24h && !params.row.logoutDate ? "red" : "inherit",
                                },
                            },
                            text
                        );
                    },
                    renderHeader: (h) => {
                        return h("div", { style: { display: "flex", alignItems: "center" } }, [
                            h("span", this.$i18n.t("usersmanage.userLoginAndLogoutRecords")),
                            h(
                                "Tooltip",
                                {
                                    props: {
                                        content: this.$i18n.t("usersmanage.sessionDurationTooltip"),
                                        placement: "top-end",
                                        maxWidth: "600px",
                                        transfer: true,
                                    },
                                },
                                [
                                    h("Icon", {
                                        props: { type: "ios-alert-outline", size: 16 },
                                    }),
                                ]
                            ),
                        ]);
                    },
                },
                {
                    title: this.$i18n.t("security.device"),
                    key: "loginDevice",
                    width: "100",
                    render: (h, params) => {
                        let iconType = "";
                        switch (params.row.loginDevice) {
                            case "mobile":
                                iconType = "md-phone-portrait";
                                break;
                            case "tablet":
                                iconType = "md-tablet-portrait";
                                break;
                            case "console":
                                iconType = "md-code-working";
                                break;
                            case "wearable":
                                iconType = "md-watch";
                                break;
                            default:
                                iconType = "md-laptop";
                        }
                        return h("div", { style: { display: "flex", "justify-content": "center" } }, [
                            h("Icon", {
                                props: {
                                    size: "25",
                                    type: iconType,
                                },
                            }),
                        ]);
                    },
                },
                {
                    title: "IP",
                    key: "loginIp",
                    width: "180",
                },
                {
                    title: "User-Agent",
                    key: "loginUserAgent",
                    width: "250",
                },
                {
                    title: this.$i18n.t("security.logoutType"),
                    key: "logoutType",
                    width: "200",
                },
            ],
            logoutInfosData: [],
            activeSessions: [],
            deviceColumns: [
                {
                    title: this.$i18n.t("security.firstValidationDate"),
                    key: "deviceFirstValidationDate",
                    sortable: true,
                    width: "250",
                },
                {
                    title: "IP",
                    key: "ip",
                    width: "250",
                },
                {
                    title: "User-Agent",
                    key: "user-agent",
                },
                {
                    title: this.$t("security.actions"),
                    key: "actions",
                    width: "100",
                    render: (h, params) => {
                        let lastLoginDate = _dateFormat(
                            `${this.$store.state.userData.lastLoginInfo.date}`,
                            "YYYY-MM-DD HH:mm:ss"
                        );
                        return h("div", { style: { display: "flex", "justify-content": "center" } }, [
                            h(
                                "Button",
                                {
                                    props: {
                                        type:
                                            params.row.deviceFirstValidationDate == lastLoginDate
                                                ? "default"
                                                : "primary",
                                        size: "small",
                                        disabled: params.row.deviceFirstValidationDate == lastLoginDate,
                                    },
                                    on: {
                                        click: () => {
                                            this.$Modal.confirm({
                                                title: this.$i18n.t("rcmtable.confirmDeleteText"),
                                                okText: this.$i18n.t("rcmtable.confirmText"),
                                                cancelText: this.$i18n.t("rcmtable.cancelText"),
                                                onOk: () => {
                                                    this.deleteDevice(params.row);
                                                },
                                            });
                                        },
                                    },
                                },
                                this.$i18n.t("security.delete")
                            ),
                        ]);
                    },
                },
            ],
            deviceData: [],
        };
    },
    methods: {
        async saveUserAllowIp() {
            // 如果isUseUserAllowIp是false
            if (!this.isUseUserAllowIp) {
                await setAllowIp({
                    isUseUserAllowIp: this.isUseUserAllowIp,
                })
                    .then(async (res) => {
                        if (res.data.success) {
                            this.$Notice.success({
                                title: this.$i18n.t("global.success"),
                                desc: `${res.data.message}`,
                            });
                            await this.getUserData();
                            this.ipValidate = false;
                        } else {
                            this.$Notice.warning({
                                title: this.$i18n.t("global.error"),
                                desc: `${res.data.message}`,
                            });
                        }
                    })
                    .catch((err) => {
                        this.$Notice.warning({
                            title: this.$i18n.t("global.error"),
                            desc: `${err.message}`,
                        });
                    });
                return;
            }

            // 如果isUseUserAllowIp是true
            this.$refs["security"].validate(async (valid) => {
                if (!valid) {
                    return this.$Notice.warning({
                        title: this.$i18n.t("global.error"),
                    });
                }

                await setAllowIp({
                    isUseUserAllowIp: this.isUseUserAllowIp,
                    userAllowIp: this.security.userAllowIp,
                })
                    .then(async (res) => {
                        if (res.data.success) {
                            this.$Notice.success({
                                title: this.$i18n.t("global.success"),
                                desc: `${res.data.message}`,
                            });
                            await this.getUserData();
                            this.ipValidate = false;
                        } else {
                            this.$Notice.warning({
                                title: this.$i18n.t("global.error"),
                                desc: `${res.data.message}`,
                            });
                        }
                    })
                    .catch((err) => {
                        this.$Notice.warning({
                            title: this.$i18n.t("global.error"),
                            desc: `${err.message}`,
                        });
                    });
            });
        },
        // 整理登入與登出紀錄
        async getSessionHistory() {
            await this.getUserData();

            const loginData = this.$store.state.userData.loginInfos;
            const logoutData = this.$store.state.userData.logoutInfos;
            this.loginAndLogOutRecordsInfosData = getSessionHistory(
                loginData,
                logoutData,
                this.$i18n.t.bind(this.$i18n),
                "security"
            );
        },
        async getActiveSessions() {
            getActiveSessions()
                .then((res) => {
                    this.activeSessions = res.data;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async destroyActiveSession(sessionId) {
            destroyActiveSession({ sessionId: sessionId })
                .then((res) => {
                    console.log(res);
                    this.getActiveSessions();
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getDeviceData() {
            this.deviceData = this.$store.state.userData.userAllowEquipList.map((userAllowEquip) => {
                return {
                    deviceFirstValidationDate: _dateFormat(
                        `${userAllowEquip.deviceFirstValidationDate}`,
                        "YYYY-MM-DD HH:mm:ss"
                    ),
                    ip: userAllowEquip.ip,
                    "user-agent": userAllowEquip["user-agent"],
                };
            });
        },
        async deleteDevice(item) {
            await _deleteDevice(item)
                .then(async (res) => {
                    if (res.data.success) {
                        this.$Notice.success({
                            title: this.$i18n.t("global.success"),
                            desc: `${res.data.message}`,
                        });
                        await this.getUserData();
                        await this.getDeviceData();
                    } else {
                        this.$Notice.warning({
                            title: this.$i18n.t("global.error"),
                            desc: `${res.data.message}`,
                        });
                    }
                })
                .catch((err) => {
                    this.$Notice.warning({
                        title: this.$i18n.t("global.error"),
                        desc: `${err.message}`,
                    });
                });
        },
        async getUserData() {
            await getUserData()
                .then((res) => {
                    this.$store.commit("SET_USER_DATA", res.data);
                })
                .catch((err) => {
                    this.$store.commit("SET_USER_DATA", {});
                    this.$router.push({ name: "login" });
                });
        },
    },
    computed: {},
    created() {
        this.getSessionHistory();
        this.getActiveSessions();
        this.getDeviceData();
    },
};
</script>

<style lang="less" scoped>
.title {
    font-size: 24px;
}
.content {
    margin-top: 20px;
}
.ivu-form-item {
    margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/view/general/AccountInfo/security.vue